import { serviceGetCards } from '@/shared/api/cards';
import {
  EVENT_CARDS_CHANGED,
  EVENT_PHYSICAL_CARD_APPEARED,
} from '@/shared/lib/events/eventsConstants';
import { Card } from '@/shared/lib/types/card';
import { ServiceListResponse } from '@/shared/lib/types/common';
import { useEventsStore } from '@/shared/store/useEventsStore';
import { useUserStore } from '@/shared/store/useUserStore';

const GENERATOR_KEY = 'generateCardChangeEvent';

export function eventsByCardsGenerate() {
  const userStore = useUserStore();
  const eventsStore = useEventsStore();
  const genState = eventsStore.generatorState(GENERATOR_KEY);
  const wasCardsInitially = genState?.hasCards ?? null;

  serviceGetCards({
    params: {
      email: userStore.getUserInfo.userEmail,
    },
  }).success((v: ServiceListResponse<'cards', Card>) => {
    const newCardsCount = v.response.cards.length;
    const activePhysicalCardsCount = v.response.cards.filter(
      card => card.status === 1 && card.typeId === 2,
    ).length;

    if (wasCardsInitially !== null && wasCardsInitially === 0 && activePhysicalCardsCount > 0) {
      eventsStore.addEvent({
        type: EVENT_PHYSICAL_CARD_APPEARED,
        title: 'Вам выдана карта',
        body: 'Теперь вы можете пользоваться личным кабинетом',
      });
    } else {
      eventsStore.addEvent({
        type: EVENT_CARDS_CHANGED,
        title: 'Изменилась информация о картах',
        body: 'Информация о ваших картах была изменена',
      });
    }

    eventsStore.addGeneratorState({
      generator: GENERATOR_KEY,
      state: {
        hasCards: newCardsCount,
      },
    });
  });
}
